"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = {
  DEFAULT_DYNO_NAME: 'My pop-up form',
  ESP_TYPES: {
    MAILCHIMP_OAUTH: 'MailChimp',
    NONE: 'none',
    CAMPAIGN_MONITOR: 'CampaignMonitor',
    AWEBER: 'AWeber',
    CONSTANT_CONTACT: 'Constant Contact',
    GET_RESPONSE: 'GetResponse'
  },
  ESP_CONNECTION_STATUS: (0, _keyMirror.default)({
    UNKNOWN: null,
    NOT_CONNECTED: null,
    CONNECTED: null,
    BROKEN: null
  }),
  ESP_MISCONFIGURED_REASON: (0, _keyMirror.default)({
    NO_CREDENTIALS: null,
    INVALID_CREDENTIALS: null
  }),
  DYNO_TYPES_NAMES: {
    BOTTOM_RIGHT: 'Slide-in Box Right',
    BOTTOM_LEFT: 'Slide-in Box Left',
    TOP: 'Dropdown Banner',
    POP_OVER: 'Popup Box'
  }
};
exports.default = _default;
module.exports = exports.default;